module.exports = __webpack_public_path__ + "img/voxicon-d27qo.cf4cff40.png";